import { Link } from "./CanonicalLink";
import { ArrowRight, BadgeCheck } from "lucide-react";
import { SPONSORED } from "../data/stories";
import { trackSponsored } from "../api";
import Reveal from "./Reveal";
import { titleCaseHeadline } from "../utils/titleCase";

export const SponsoredStrip = () => {
  const fireImpression = (id) => {
    const key = `std-sponsor-imp-${id}`;
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, "1");
      trackSponsored(id, "impression");
    }
  };

  return (
    <section
      data-testid="sponsored-section"
      className="bg-[#d2f8fc] border-y border-[#b7e9f0]"
    >
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 py-12">
        <Reveal>
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className="text-[10px] font-extrabold uppercase tracking-[0.28em] text-[#4a7c85]">
              Sponsored content
            </p>
            <p className="text-[10px] uppercase tracking-[0.18em] text-[#6d9aa3]">
              Paid for by our partners
            </p>
          </div>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-5">
          {SPONSORED.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.08} className="h-full">
              <a
                href={item.url}
                
                rel="noreferrer sponsored"
                onMouseEnter={() => fireImpression(item.id)}
                onFocus={() => fireImpression(item.id)}
                onClick={() => trackSponsored(item.id, "click")}
                ref={(el) => el && fireImpression(item.id)}
                data-testid={`sponsored-card-${item.id}`}
                className="h-full flex flex-col bg-white/80 border border-[#b7e9f0] p-6 hover:shadow-[0_14px_34px_rgba(74,124,133,0.22)] hover:-translate-y-0.5 transition-all duration-300"
              >
                <span className="inline-flex items-center gap-1.5 self-start bg-[#d2f8fc] border border-[#b7e9f0] text-[#4a7c85] text-[9px] font-extrabold uppercase tracking-[0.2em] px-2 py-1">
                  <BadgeCheck size={11} /> Sponsored
                </span>
                <p className="mt-4 text-[10px] font-extrabold uppercase tracking-[0.22em] text-[#cf0a0a]">
                  {item.brand}
                </p>
                <h3 className="mt-2 font-display text-xl leading-snug font-semibold line-clamp-3">
                  {titleCaseHeadline(item.title)}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-[var(--muted)] line-clamp-3">
                  {item.note}
                </p>
                <span className="mt-auto pt-5 inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-[#141414] group">
                  Read story
                  <ArrowRight size={13} className="text-[#cf0a0a] transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SponsoredStrip;
